export default __webpack_public_path__ + "static/media/👏🏻.361bec56.svg";